import styled from "styled-components";

import { ANIMATION } from "../../utils/constants";
import { BaseButton } from "../Button";

export const StyledFab = styled(BaseButton)`
  justify-content: center;
  width: 56px;
  height: 56px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--color-primary-color-background);
  color: var(--color-white);
  box-shadow: var(--shadow-large);
  transition: all ${ANIMATION.duration.moderate} ${ANIMATION.easing.standard};

  &:hover:not(:disabled) {
    background: var(--gradient-primary);
    transform: scale(1.05);
    box-shadow: var(--shadow-large-3);
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    width: 52px;
    height: 52px;
  }

  @media (prefers-reduced-motion: reduce) {
    &:hover:not(:disabled),
    &:active:not(:disabled) {
      transform: none;
    }
  }
`;
